import React, { useState, useRef, useEffect, useCallback } from "react";
import styled, { keyframes, css } from "styled-components";
import { TextareaAutosize } from "@material-ui/core";
import AuthService from "../../../../services/AuthService";

const API_BASE = "https://justask-backend.vercel.app";
const CHAT_ENDPOINT = `${API_BASE}/api/chat`;
const CASE_LOOKUP_ENDPOINT = `${API_BASE}/api/case-lookup`;
const OTP_SEND_ENDPOINT = `${API_BASE}/api/otp-send`;
const OTP_VERIFY_ENDPOINT = `${API_BASE}/api/otp-verify`;

const COUNTRY_CODES = [
  { code: "+91", flag: "🇮🇳" },
  { code: "+1", flag: "🇺🇸" },
  { code: "+44", flag: "🇬🇧" },
  { code: "+971", flag: "🇦🇪" },
  { code: "+65", flag: "🇸🇬" },
  { code: "+61", flag: "🇦🇺" },
  { code: "+49", flag: "🇩🇪" },
  { code: "+81", flag: "🇯🇵" },
  { code: "+86", flag: "🇨🇳" },
  { code: "+977", flag: "🇳🇵" },
  { code: "+94", flag: "🇱🇰" },
  { code: "+880", flag: "🇧🇩" },
  { code: "+92", flag: "🇵🇰" },
  { code: "+966", flag: "🇸🇦" },
  { code: "+55", flag: "🇧🇷" },
];

const CASE_ID_PATTERN = /^IAMC-[A-Z]{2,4}-\d{4}-\d{3,5}$/i;

const C = {
  teal: "#00838c",
  tealDark: "#00A88A",
  tealGlow: "rgba(0,212,170,0.20)",
  tealGlow2: "rgba(0,212,170,0.10)",
  accent: "#7B61FF",
  accentGlow: "rgba(123,97,255,0.18)",
  bg: "transparent" /* Hero bg is now handled by HeroBanner layers */,
  bg2: "rgba(13,26,46,0.60)" /* used for InputArea glass layer */,
  surface: "rgba(255,255,255,0.04)",
  surfaceHover: "rgba(255,255,255,0.07)",
  border: "rgba(255,255,255,0.08)",
  borderAccent: "rgba(0,131,140,0.28)",
  white: "#FFFFFF",
  text: "rgba(255,255,255,0.90)",
  textSub: "rgba(255,255,255,0.50)",
  textMuted: "rgba(255,255,255,0.30)",
};

const fadeUp = keyframes`
  from { opacity:0; transform:translateY(20px); }
  to   { opacity:1; transform:translateY(0); }
`;
const msgIn = keyframes`
  from { opacity:0; transform:translateY(12px) scale(0.97); }
  to   { opacity:1; transform:translateY(0) scale(1); }
`;
const pulse = keyframes`
  0%,100% { box-shadow: 0 0 0 0 rgba(0,212,170,0.4), 0 0 30px rgba(0,212,170,0.1); }
  50%      { box-shadow: 0 0 0 16px rgba(0,212,170,0), 0 0 50px rgba(0,212,170,0.2); }
`;
const orb1 = keyframes`
  0%,100% { transform: translate(0,0) scale(1); }
  33%      { transform: translate(40px,-30px) scale(1.1); }
  66%      { transform: translate(-20px,20px) scale(0.95); }
`;
const orb2 = keyframes`
  0%,100% { transform: translate(0,0) scale(1); }
  33%      { transform: translate(-50px,20px) scale(1.05); }
  66%      { transform: translate(30px,-40px) scale(0.9); }
`;
const orb3 = keyframes`
  0%,100% { transform: translate(0,0) scale(1); }
  50%      { transform: translate(20px,30px) scale(1.08); }
`;
const gridPan = keyframes`
  0%   { background-position: 0 0; }
  100% { background-position: 40px 40px; }
`;

const shimmer = keyframes`
  0%   { background-position: -200% center; }
  100% { background-position: 200% center; }
`;

const scalePulse = keyframes`
  0%, 100% { transform: scale(0.6); opacity: 0.4; }
  50%       { transform: scale(1);   opacity: 1; }
`;

/*

function OwlAvatar({ size = 44 }) {
  return (
    <svg
      viewBox="0 0 44 44"
      width={size}
      height={size}
      style={{ display: "block" }}
    >
      <defs>
        <radialGradient id="owlGlow1" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#00838c" stopOpacity="0.6" />
          <stop offset="100%" stopColor="#00838c" stopOpacity="0" />
        </radialGradient>
        <radialGradient id="owlGlow2" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#7B61FF" stopOpacity="0.5" />
          <stop offset="100%" stopColor="#7B61FF" stopOpacity="0" />
        </radialGradient>
      </defs>
      <ellipse cx="22" cy="25" rx="15" ry="14" fill="url(#owlGlow1)" />
      <circle
        cx="15"
        cy="18"
        r="7"
        fill="none"
        stroke="#00838c"
        strokeWidth="1.5"
        strokeOpacity="0.6"
      />
      <circle cx="15" cy="18" r="4.5" fill="rgba(0,212,170,0.2)" />
      <circle cx="15" cy="18" r="2.8" fill="white" />
      <circle cx="15.6" cy="17.4" r="1.1" fill="#040B1A" />
      <circle cx="16.1" cy="17" r="0.4" fill="white" />
      <circle
        cx="29"
        cy="18"
        r="7"
        fill="none"
        stroke="#00838c"
        strokeWidth="1.5"
        strokeOpacity="0.6"
      />
      <circle cx="29" cy="18" r="4.5" fill="rgba(0,212,170,0.2)" />
      <circle cx="29" cy="18" r="2.8" fill="white" />
      <circle cx="29.6" cy="17.4" r="1.1" fill="#040B1A" />
      <circle cx="30.1" cy="17" r="0.4" fill="white" />
      <path d="M20.5 23 L22 25.5 L23.5 23" fill="#00838c" opacity="0.9" />
      <path d="M10 10 L13 15 L8 14Z" fill="rgba(0,212,170,0.4)" />
      <path d="M34 10 L31 15 L36 14Z" fill="rgba(0,212,170,0.4)" />
    </svg>
  );
}

*/

/*


function MiniOwlAvatar() {
  return (
    <svg
      viewBox="0 0 20 20"
      width="16"
      height="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      
      <circle
        cx="10"
        cy="10"
        r="8.5"
        fill="none"
        stroke="#006D77"
        strokeWidth="1"
        opacity="0.18"
      />

      
      <path
        d="M13.2 5.8
           L13.2 12.8
           C13.2 14.6 11.1 15.1 8.8 13.9"
        fill="none"
        stroke="#006D77"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="13.7" cy="5.7" r="0.9" fill="#006D77" />
    </svg>
  );
}

*/
function SendIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ width: 16, height: 16 }}
    >
      <line x1="22" y1="2" x2="11" y2="13" />
      <polygon points="22 2 15 22 11 13 2 9 22 2" />
    </svg>
  );
}

function OtpInputWithClass({ onComplete }) {
  const [values, setValues] = useState(["", "", "", "", "", ""]);
  const refs = useRef([]);
  const handleChange = (index, val) => {
    if (val.length > 1) val = val[0];
    const next = [...values];
    next[index] = val;
    setValues(next);
    if (val && index < 5) refs.current[index + 1].focus();
  };
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !values[index] && index > 0)
      refs.current[index - 1].focus();
  };
  useEffect(() => {
    refs.current[0].focus();
  }, []);
  return (
    <OtpRow>
      {values.map((v, i) => (
        <OtpBox
          key={i}
          ref={(el) => (refs.current[i] = el)}
          className="ja-otp-box"
          type="text"
          maxLength="1"
          value={v}
          $filled={!!v}
          onChange={(e) => handleChange(i, e.target.value)}
          onKeyDown={(e) => handleKeyDown(e, i)}
          inputMode="numeric"
        />
      ))}
    </OtpRow>
  );
}

function CaseCard({ caseDetails }) {
  const c = caseDetails;
  const badgeType =
    c.status?.includes("Scheduled") || c.status?.includes("Progress")
      ? "active"
      : c.status?.includes("Settled") || c.status?.includes("Resolved")
        ? "resolved"
        : "review";
  return (
    <CardWrap>
      <CardHeader>
        <CardId>{c.caseId}</CardId>
        <StatusBadge $type={badgeType}>{c.status}</StatusBadge>
      </CardHeader>
      {[
        ["Case Type", c.caseType],
        ["Track", c.track],
        ["Filed", c.filedDate],
      ].map(([k, v]) => (
        <CardRow key={k}>
          <span>{k}</span>
          <span>{v}</span>
        </CardRow>
      ))}
      {c.neutral?.name && (
        <CardRow>
          <span>{c.neutral.role || "Neutral"}</span>
          <span>{c.neutral.name}</span>
        </CardRow>
      )}
      {c.nextHearing && (
        <CardHighlight $type="hearing">
          <strong>Next Hearing:</strong> {c.nextHearing.date} at{" "}
          {c.nextHearing.time} ({c.nextHearing.mode})
        </CardHighlight>
      )}
      {c.actionRequired && !c.actionRequired.includes("None") && (
        <CardHighlight $type="action">
          <strong>Action Required:</strong> {c.actionRequired}
        </CardHighlight>
      )}
    </CardWrap>
  );
}

function InlineCaseIdInput({ prefill, onSubmit }) {
  const [value, setValue] = useState(prefill || "");
  const ref = useRef(null);
  useEffect(() => {
    if (!prefill) ref.current.focus();
  }, [prefill]);
  return (
    <InlineWrap>
      <CaseInput
        ref={ref}
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="e.g. IAMC-ARB-2024-0156"
        onKeyDown={(e) => e.key === "Enter" && onSubmit(value)}
        readOnly={!!prefill}
        style={prefill ? { opacity: 0.65 } : {}}
      />
      <CaseBtn onClick={() => onSubmit(value)}>
        {prefill ? "Verify This Case ID" : "Verify Case ID"}
      </CaseBtn>
    </InlineWrap>
  );
}

function InlineRoleSelect({ roles, onSubmit }) {
  const [value, setValue] = useState("");
  return (
    <InlineWrap>
      <CaseSelect value={value} onChange={(e) => setValue(e.target.value)}>
        <option value="">— Select your role —</option>
        {roles.map((r) => (
          <option key={r} value={r}>
            {r}
          </option>
        ))}
      </CaseSelect>
      <CaseBtn onClick={() => onSubmit(value)}>Continue</CaseBtn>
    </InlineWrap>
  );
}

function InlineEmailInput({ onSubmit }) {
  const [value, setValue] = useState("");
  const ref = useRef(null);
  useEffect(() => {
    ref.current.focus();
  }, []);
  return (
    <InlineWrap>
      <CaseInput
        ref={ref}
        type="email"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="your.email@example.com"
        onKeyDown={(e) => e.key === "Enter" && onSubmit(value)}
      />
      <CaseBtn onClick={() => onSubmit(value)}>Verify Email</CaseBtn>
    </InlineWrap>
  );
}

function InlineOtpSubmit({ onSubmit }) {
  const handleClick = () => {
    const boxes = document.querySelectorAll(".ja-otp-box");
    const val = Array.from(boxes)
      .slice(-6)
      .map((b) => b.value)
      .join("");
    if (val.length === 6) onSubmit(val);
  };
  return (
    <CaseBtn style={{ marginTop: 10 }} onClick={handleClick}>
      Verify OTP
    </CaseBtn>
  );
}

function InlineLeadForm({ onSubmit }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [location, setLocation] = useState("");
  const [textarea, setTextarea] = useState("");
  const [cc, setCc] = useState("+91");
  return (
    <InlineWrap>
      <CaseInput
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Your Full Name *"
      />
      <CaseInput
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Email Address *"
      />
      <PhoneRow>
        <CaseSelect
          value={cc}
          onChange={(e) => setCc(e.target.value)}
          style={{ width: 108, flexShrink: 0 }}
        >
          {COUNTRY_CODES.map((c) => (
            <option key={c.code} value={c.code}>
              {c.flag} {c.code}
            </option>
          ))}
        </CaseSelect>
        <CaseInput
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="Phone (optional)"
          style={{ flex: 1 }}
        />
      </PhoneRow>
      <CaseInput
        type="text"
        value={location}
        onChange={(e) => setLocation(e.target.value)}
        placeholder="Enter your location"
      />
      <CustomTextArea
        type="text"
        style={{ backgroundColor: "rgba(255, 255, 255, 0.05)" }}
        value={textarea}
        onChange={(e) => setTextarea(e.target.value)}
        placeholder="Enter your message *"
        rows={5}
      />
      <CaseBtn
        onClick={() => onSubmit({ name, email, phone, cc, location, textarea })}
      >
        Request Callback
      </CaseBtn>
    </InlineWrap>
  );
}

export default function JustAskHero() {
  const [messages, setMessages] = useState([]);
  const [conversationHistory, setConversationHistory] = useState([]);
  const [convoStarted, setConvoStarted] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [caseData, setCaseData] = useState({});
  const convoAreaRef = useRef(null);
  const inputRef = useRef(null);
  const msgIdRef = useRef(0);
  const nextMsgId = () => {
    msgIdRef.current += 1;
    return msgIdRef.current;
  };

  const width = window.innerWidth;
  const height = window.innerHeight;

  console.log(width, height);

  const enterConvoMode = useCallback(() => {
    setConvoStarted(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const addBotMsg = useCallback(
    (html, extra = null) => {
      enterConvoMode();
      setMessages((prev) => [
        ...prev,
        { id: nextMsgId(), type: "bot", html, extra },
      ]);
    },
    [enterConvoMode],
  );

  const addUserMsg = useCallback(
    (text) => {
      enterConvoMode();
      setMessages((prev) => [...prev, { id: nextMsgId(), type: "user", text }]);
      setConversationHistory((prev) => [
        ...prev,
        { role: "user", content: text },
      ]);
    },
    [enterConvoMode],
  );

  useEffect(() => {
    if (convoAreaRef.current)
      convoAreaRef.current.scrollTop = convoAreaRef.current.scrollHeight;
  }, [messages, isTyping]);

  const resetConvo = useCallback(() => {
    setMessages([]);
    setConversationHistory([]);
    setConvoStarted(false);
    setIsTyping(false);
    setCaseData({});
    window.scrollTo({ top: 0, behavior: "smooth" });
    setTimeout(() => inputRef.current?.focus(), 400);
  }, []);

  const sendMessage = useCallback(
    async (overrideText) => {
      const text = (overrideText || inputValue).trim();
      if (!text) return;
      if (!overrideText) setInputValue("");
      if (CASE_ID_PATTERN.test(text)) {
        addUserMsg(text);
        addBotMsg(
          "I see you've entered a Case ID! For security, let me take you through the proper verification flow. 🔐",
          { type: "caseIdInput", prefill: text },
        );
        return;
      }
      addUserMsg(text);
      setIsTyping(true);
      try {
        const res = await fetch(CHAT_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            message: text,
            history: conversationHistory.slice(-24),
          }),
        });
        const data = await res.json();
        setIsTyping(false);
        const reply = data.reply || data.error || "Something went wrong.";
        setConversationHistory((prev) => [
          ...prev,
          { role: "assistant", content: reply },
        ]);
        addBotMsg(
          reply,
          data.buttons?.length
            ? { type: "buttons", buttons: data.buttons }
            : null,
        );
      } catch {
        setIsTyping(false);
        addBotMsg("I couldn't connect right now. Please try again.");
      }
      inputRef.current.focus();
    },
    [inputValue, conversationHistory, addUserMsg, addBotMsg],
  );

  const handleButtonClick = useCallback(
    (label) => {
      if (label === "Start Over" || label === "Ask something else") {
        resetConvo();
        return;
      }
      if (label === "Check my case status") {
        // startCaseFlow();
        sendMessage("Check my case status");
        return;
      }
      if (label === "Get In Touch") {
        startLeadFlow();
        return;
      }
      if (label.includes("send OTP")) {
        sendCaseOTP();
        return;
      }
      if (label === "Cancel") {
        resetConvo();
        return;
      }
      sendMessage(label);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [resetConvo, sendMessage],
  );

  const startCaseFlow = useCallback(() => {
    enterConvoMode();
    addBotMsg(
      `Case status tracking is coming soon to JustAsk! We're building a secure, verified way for you to check hearing dates, arbitrator details, and case progress right here. For now, your Scrutiny Clerk has you covered — contact support@IAMC.co.in or +91 95009 09888.`,
      {
        type: "buttons",
        buttons: ["Start Over"],
      },
    );

    /*
    addBotMsg(
      "I can help you check your case status securely. <br/><br/>Please enter your <strong>Case ID</strong> below.",
      { type: "caseIdInput" },
    );
    */
  }, [enterConvoMode, addBotMsg]);

  const submitCaseId = useCallback(
    async (caseId) => {
      if (!caseId.trim()) return;
      addUserMsg(caseId);
      setIsTyping(true);
      try {
        const res = await fetch(CASE_LOOKUP_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ caseId }),
        });
        const data = await res.json();
        setIsTyping(false);
        if (!data.found) {
          addBotMsg(
            `${data.error}<br/><br/>Your Case ID looks like: <strong>IAMC-XXX-YYYY-ZZZZ</strong>`,
            { type: "caseIdInput" },
          );
          return;
        }
        setCaseData({
          caseId: data.caseId,
          caseType: data.caseType,
          roles: data.roles,
        });
        addBotMsg(
          `Case found! This is a <strong>${data.caseType}</strong> case.<br/><br/>Please select your role:`,
          { type: "roleSelect", roles: data.roles },
        );
      } catch {
        setIsTyping(false);
        addBotMsg("Couldn't connect to the case system. Please try again.");
      }
    },
    [addUserMsg, addBotMsg],
  );

  const submitRole = useCallback(
    (role) => {
      if (!role) return;
      setCaseData((prev) => ({ ...prev, selectedRole: role }));
      addUserMsg(role);
      addBotMsg(
        `Thanks! As the <strong>${role}</strong>, please enter your registered email address:`,
        { type: "emailVerify" },
      );
    },
    [addUserMsg, addBotMsg],
  );

  const submitEmailVerify = useCallback(
    async (email) => {
      if (!email.trim()) return;
      addUserMsg(email);
      setIsTyping(true);
      try {
        const res = await fetch(CASE_LOOKUP_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            caseId: caseData.caseId,
            role: caseData.selectedRole,
            email,
          }),
        });
        const data = await res.json();
        setIsTyping(false);
        if (!data.verified) {
          addBotMsg(`${data.error}`, { type: "emailVerify" });
          return;
        }
        setCaseData((prev) => ({
          ...prev,
          maskedPhone: data.maskedPhone,
          partyName: data.partyName,
          verifiedRole: data.role,
        }));
        addBotMsg(
          `Verified, <strong>${data.partyName}</strong>!<br/><br/>I'll send an OTP to <strong>${data.maskedPhone}</strong>. Ready?`,
          { type: "buttons", buttons: ["📱 Yes, send OTP", "Cancel"] },
        );
      } catch {
        setIsTyping(false);
        addBotMsg("Couldn't verify. Please try again.");
      }
    },
    [caseData, addUserMsg, addBotMsg],
  );

  const sendCaseOTP = useCallback(async () => {
    addUserMsg("Yes, send OTP");
    setIsTyping(true);
    try {
      const res = await fetch(OTP_SEND_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          caseId: caseData.caseId,
          role: caseData.verifiedRole,
        }),
      });
      const data = await res.json();
      setIsTyping(false);
      addBotMsg(
        `📲 OTP sent to <strong>${caseData.maskedPhone}</strong>!<br/>Enter the 6-digit code below.` +
          (data.demoOtp
            ? `<br/><br/><span style="color:rgba(255,255,255,0.3);font-size:0.72rem">🧪 Demo: <strong>${data.demoOtp}</strong></span>`
            : ""),
        { type: "otpInput" },
      );
    } catch {
      setIsTyping(false);
      addBotMsg("Couldn't send OTP. Try again.");
    }
  }, [caseData, addUserMsg, addBotMsg]);

  const verifyCaseOTP = useCallback(
    async (otp) => {
      if (otp.length !== 6) return;
      addUserMsg("••••••");
      setIsTyping(true);
      try {
        const res = await fetch(OTP_VERIFY_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            caseId: caseData.caseId,
            role: caseData.verifiedRole,
            otp,
          }),
        });
        const data = await res.json();
        setIsTyping(false);
        if (!data.verified) {
          addBotMsg(`${data.error}`, { type: "otpInput" });
          return;
        }
        addBotMsg("Here are your case details:", {
          type: "caseCard",
          caseDetails: data.caseDetails,
        });
      } catch {
        setIsTyping(false);
        addBotMsg("Verification failed. Try again.");
      }
    },
    [caseData, addUserMsg, addBotMsg],
  );

  const startLeadFlow = useCallback(() => {
    enterConvoMode();
    addBotMsg(
      "I'd love to connect you with a IAMC expert. Share your details and our team will reach out shortly.",
      { type: "leadForm" },
    );
  }, [enterConvoMode, addBotMsg]);

  const submitLead = useCallback(
    async ({ name, email, phone, cc, location, textarea }) => {
      if (!name || !email || !textarea) {
        addBotMsg("Please fill in your name, email and message.");
        return;
      }
      setIsTyping(true);
      try {
        const payload = {
          fullName: name,
          email: email,
          phone: phone ? `${cc} ${phone}` : "",
          location: location,
          message: textarea,
        };
        await AuthService.enquireMail(payload);
        setIsTyping(false);
        addBotMsg(
          `Thank you, <strong>${name}</strong>! Our team will reach out to <strong>${email}</strong> shortly.`,
          {
            type: "buttons",
            buttons: [
              "Learn about services",
              "How does arbitration work?",
              "Start Over",
            ],
          },
        );
      } catch {
        setIsTyping(false);
        addBotMsg("Couldn't submit. Please try again or call +91 95009 09888.");
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [conversationHistory, addBotMsg],
  );

  const handleInputKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };
  const autoResize = (el) => {
    el.style.height = "auto";
    el.style.height = Math.min(el.scrollHeight, 120) + "px";
  };

  const renderExtra = (extra) => {
    if (!extra) return null;
    switch (extra.type) {
      case "buttons":
        return (
          <MsgButtons>
            {extra.buttons.map((b, i) => (
              <MsgBtn key={i} onClick={() => handleButtonClick(b)}>
                {b}
              </MsgBtn>
            ))}
          </MsgButtons>
        );
      case "caseIdInput":
        return (
          <InlineCaseIdInput prefill={extra.prefill} onSubmit={submitCaseId} />
        );
      case "roleSelect":
        return <InlineRoleSelect roles={extra.roles} onSubmit={submitRole} />;
      case "emailVerify":
        return <InlineEmailInput onSubmit={submitEmailVerify} />;
      case "otpInput":
        return (
          <div style={{ marginTop: 10 }}>
            <OtpInputWithClass onComplete={() => {}} />
            <InlineOtpSubmit onSubmit={verifyCaseOTP} />
          </div>
        );
      case "caseCard":
        return (
          <>
            <CaseCard caseDetails={extra.caseDetails} />
            <MsgButtons style={{ marginTop: 10 }}>
              <MsgBtn onClick={() => handleButtonClick("Start Over")}>
                Start Over
              </MsgBtn>
            </MsgButtons>
          </>
        );
      case "leadForm":
        return <InlineLeadForm onSubmit={submitLead} />;
      default:
        return null;
    }
  };

  return (
    <Hero $expanded={convoStarted}>
      <Orb
        $color="rgba(0,131,140,0.14)"
        $size="600px"
        $top="10%"
        $left="5%"
        $anim={orb1}
      />
      <Orb
        $color="rgba(41,52,97,0.45)"
        $size="500px"
        $top="40%"
        $left="60%"
        $anim={orb2}
      />
      <Orb
        $color="rgba(0,131,140,0.08)"
        $size="400px"
        $top="70%"
        $left="20%"
        $anim={orb3}
      />
      <GridOverlay />
      <NoiseTex />

      {convoStarted ? (
        <ChatShell>
          <ConvoArea ref={convoAreaRef}>
            {messages.map((msg) => (
              <MsgRow key={msg.id} $user={msg.type === "user"}>
                {msg.type === "bot" && (
                  <MsgAvatar>
                    {/* <MiniOwlAvatar /> */}
                    {/* <OwlAvatar /> */}
                    <MiniAvatarImage src="https://justact-api-uploads.s3.ap-south-1.amazonaws.com/13/1774940331107-1ce434bf-cd24-414a-831b-9ef791225ec9/just_ask.jpg" />
                  </MsgAvatar>
                )}
                <MsgContent $user={msg.type === "user"}>
                  {msg.type === "bot" ? (
                    <MsgBubble
                      $user={false}
                      dangerouslySetInnerHTML={{ __html: msg.html }}
                    />
                  ) : (
                    <MsgBubble $user={true}>{msg.text}</MsgBubble>
                  )}
                  {msg.type === "bot" && renderExtra(msg.extra)}
                </MsgContent>
              </MsgRow>
            ))}
            {isTyping && (
              <TypingRow>
                <MsgAvatar>
                  {/* <MiniOwlAvatar /> */}
                  {/* <OwlAvatar /> */}
                  <MiniAvatarImage src="https://justact-api-uploads.s3.ap-south-1.amazonaws.com/13/1774940331107-1ce434bf-cd24-414a-831b-9ef791225ec9/just_ask.jpg" />
                </MsgAvatar>
                <TypingBubble>
                  {/* <JABadge>JA</JABadge> */}
                  <TDot />
                  <TDot />
                  <TDot />
                </TypingBubble>
              </TypingRow>
            )}
          </ConvoArea>

          <InputArea>
            <InputWrap>
              <InputBar
                ref={inputRef}
                placeholder="Type your message…"
                rows="1"
                value={inputValue}
                onChange={(e) => {
                  setInputValue(e.target.value);
                  autoResize(e.target);
                }}
                onKeyDown={handleInputKey}
              />
              <SendBtn
                $active={!!inputValue.trim()}
                onClick={() => sendMessage()}
              >
                <SendIcon />
              </SendBtn>
            </InputWrap>
          </InputArea>
        </ChatShell>
      ) : (
        <IdleContent>
          <AvatarRing>
            {/* <OwlAvatar  size={44} /> */}
            <AvatarImage src="https://justact-api-uploads.s3.ap-south-1.amazonaws.com/13/1774940331107-1ce434bf-cd24-414a-831b-9ef791225ec9/just_ask.jpg" />
            <RingOuter />
            <RingInner />
          </AvatarRing>
          <HeroTitle>
            <GradientSpan>JustAsk</GradientSpan>
          </HeroTitle>
          <HeroSub>
            Your intelligent guide to arbitration, mediation & dispute
            resolution. Ask anything or check your case status instantly.
          </HeroSub>

          <InputWrap>
            <InputBar
              ref={inputRef}
              placeholder="Describe your dispute or ask me anything…"
              rows="1"
              value={inputValue}
              onChange={(e) => {
                setInputValue(e.target.value);
                autoResize(e.target);
              }}
              onKeyDown={handleInputKey}
            />
            <SendBtn
              $active={!!inputValue.trim()}
              onClick={() => sendMessage()}
            >
              <SendIcon />
            </SendBtn>
          </InputWrap>

          <ChipsContainer>
            <ChipsRow>
              {[
                "How does online arbitration work?",
                "I have a payment dispute",
                "Mediation vs Arbitration?",
              ].map((t) => (
                <Chip key={t} onClick={() => sendMessage(t)}>
                  {t}
                </Chip>
              ))}
            </ChipsRow>
            <ChipsRow>
              <Chip
                $case
                $comingSoon
                onClick={() => sendMessage("Check my case status")}
              >
                Check my case status
              </Chip>
              <Chip onClick={() => sendMessage("What does JustAct cost?")}>
                What does IAMC cost?
              </Chip>
              <Chip $case onClick={startLeadFlow}>
                Get In Touch
              </Chip>
            </ChipsRow>
          </ChipsContainer>
        </IdleContent>
      )}
    </Hero>
  );
}

const Hero = styled.section`
  position: relative;
  width: 100%;
  background: transparent;
  overflow: hidden;
  ${(p) =>
    !p.$expanded &&
    css`
      min-height: 100vh;
      min-height: 100dvh;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 60px 20px 40px;
    `}
  ${(p) =>
    p.$expanded &&
    css`
      height: calc(100vh - 62px);
      height: calc(100svh - 62px);
      height: calc(100dvh - 62px);
      max-height: calc(100vh - 62px);
      max-height: calc(100svh - 62px);
      max-height: calc(100dvh - 62px);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      overflow: hidden;
    `}
  @media (max-width: 768px) {
    ${(p) =>
      !p.$expanded &&
      css`
        min-height: 100vh;
        min-height: 100svh;
        padding: 40px 16px 32px;
      `}
    ${(p) =>
      p.$expanded &&
      css`
        height: calc(100vh - 56px);
        height: calc(100svh - 56px);
        height: calc(100dvh - 56px);
        max-height: calc(100vh - 56px);
        max-height: calc(100svh - 56px);
        max-height: calc(100dvh - 56px);
      `}
  }
  @media (max-width: 480px) {
    ${(p) =>
      !p.$expanded &&
      css`
        padding: 30px 12px 24px;
      `}
  }
`;

const Orb = styled.div`
  position: absolute;
  top: ${(p) => p.$top};
  left: ${(p) => p.$left};
  width: ${(p) => p.$size};
  height: ${(p) => p.$size};
  border-radius: 50%;
  background: radial-gradient(circle, ${(p) => p.$color} 0%, transparent 70%);
  animation: ${(p) => p.$anim} 18s ease-in-out infinite;
  pointer-events: none;
  filter: blur(1px);
  @media (max-width: 768px) {
    width: calc(${(p) => p.$size} * 0.6);
    height: calc(${(p) => p.$size} * 0.6);
  }
`;

const GridOverlay = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image:
    linear-gradient(rgba(0, 131, 140, 0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 131, 140, 0.04) 1px, transparent 1px);
  background-size: 40px 40px;
  animation: ${gridPan} 8s linear infinite;
  mask-image: radial-gradient(ellipse at 50% 50%, black 20%, transparent 80%);
`;

const NoiseTex = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.025;
  background-size: 200px 200px;
`;

const IdleContent = styled.div`
  position: relative;
  z-index: 2;
  width: 60%;
  max-width: 720px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0;

  @media (max-width: 1024px) {
    width: 75%;
  }
  @media (max-width: 768px) {
    width: 90%;
  }
  @media (max-width: 480px) {
    width: 100%;
  }
`;

const RingOuter = styled.div`
  position: absolute;
  inset: -10px;
  border-radius: 50%;
  border: 1px solid rgba(0, 131, 140, 0.25);
  animation: ${pulse} 3s ease-in-out infinite;
`;
const RingInner = styled.div`
  position: absolute;
  inset: -5px;
  border-radius: 50%;
  border: 1px solid rgba(0, 131, 140, 0.14);
`;

const AvatarImage = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
  z-index: 2;
`;

const AvatarRing = styled.div`
  position: relative;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  background: linear-gradient(
    135deg,
    rgba(0, 131, 140, 0.18),
    rgba(41, 52, 97, 0.25)
  );
  border: 1.5px solid rgba(0, 131, 140, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 22px;
  animation: ${fadeUp} 0.5s ease forwards 0.1s;
  opacity: 0;
  @media (max-width: 480px) {
    width: 64px;
    height: 64px;
  }
`;

const HeroTitle = styled.h1`
  font-family: openSans-SemiBold, sans-serif;
  font-size: clamp(1.8rem, 5vw, 2.8rem);
  font-weight: 700;
  color: ${C.white};
  margin-bottom: 12px;
  line-height: 1.15;
  animation: ${fadeUp} 0.5s ease forwards 0.2s;
  opacity: 0;
`;

const GradientSpan = styled.span`
  background: linear-gradient(
    135deg,
    ${C.teal} 0%,
    #5eead4 50%,
    ${C.accent} 100%
  );
  background-size: 200% 100%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: ${shimmer} 4s linear infinite;
`;

const HeroSub = styled.p`
  font-family: openSans-Regular, sans-serif;
  font-size: clamp(0.875rem, 2.5vw, 1rem);
  color: ${C.textSub};
  margin-bottom: 32px;
  max-width: 90%;
  line-height: 1.7;
  animation: ${fadeUp} 0.5s ease forwards 0.3s;
  opacity: 0;
`;

const ChatShell = styled.div`
  position: relative;
  z-index: 2;
  width: 80%;
  max-width: 860px;
  height: 100%;
  min-height: 0; /* Critical for Safari: prevents flex child from overflowing */
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: 1024px) {
    width: 85%;
  }
  @media (max-width: 768px) {
    width: 95%;
    max-width: 100%;
  }
  @media (max-width: 480px) {
    width: 100%;
    max-width: 100%;
  }
`;

const ConvoArea = styled.div`
  flex: 1 1 0%;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 0;
  min-height: 0; /* Safari fix: allows flex shrinking for scroll */
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    // background: rgba(0, 212, 170, 0.2);
    border-radius: 4px;
  }
  @media (max-width: 480px) {
    padding: 12px;
  }
`;

const MsgRow = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
  animation: ${msgIn} 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) both;
  justify-content: ${(p) => (p.$user ? "flex-end" : "flex-start")};
  align-items: flex-start;
`;

const MsgAvatar = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 131, 140, 0.1);
  border: 1px solid rgba(0, 131, 140, 0.28);
  margin-top: 2px;
`;

const MiniAvatarImage = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
  z-index: 2;
`;

const MsgContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${(p) => (p.$user ? "flex-end" : "flex-start")};
  max-width: 80%;
  @media (max-width: 480px) {
    max-width: 88%;
  }
`;

const MsgBubble = styled.div`
  padding: 12px 16px;
  font-size: 0.875rem;
  line-height: 1.65;
  word-break: break-word;
  font-family: openSans-Regular, sans-serif;
  ${(p) =>
    p.$user
      ? css`
          background: linear-gradient(135deg, ${C.teal} 0%);
          color: #ffffff;
          font-family: openSans-Regular, sans-serif;
          border-radius: 20px 20px 4px 20px;
          border: 1px solid rgba(0, 212, 170, 0.25);
          box-shadow: 0 4px 20px rgba(0, 212, 170, 0.3);
        `
      : css`
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.08);
          color: ${C.text};
          border-radius: 4px 20px 20px 20px;
          backdrop-filter: blur(10px);
        `}
  strong {
    font-weight: 700;
  }
  a {
    color: ${C.teal};
  }
`;

const TypingRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  padding-bottom: 12px;
  animation: ${fadeUp} 0.25s ease;
`;

/*

const JABadge = styled.span`
  font-size: 11px;
  font-weight: 500;
  color: #00838c;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  padding: 3px 7px;
  letter-spacing: 0.04em;
`;

*/

const TypingBubble = styled.div`
  display: inline-flex;
  gap: 10px;
  align-items: center;
  padding: 12px 18px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 4px 16px 16px 16px;
  backdrop-filter: blur(10px);
`;

const TDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${C.teal};
  animation: ${scalePulse} 1.2s ease-in-out infinite;
  &:nth-child(2) {
    animation-delay: 0.18s;
  }
  &:nth-child(3) {
    animation-delay: 0.36s;
  }
`;

const InputArea = styled.div`
  flex: 0 0 auto; /* Never shrink, never grow — always visible */
  width: 100%;
  padding: 12px 20px 16px;
  // background: rgba(13, 26, 46, 0.55);
  // backdrop-filter: blur(20px);
  // -webkit-backdrop-filter: blur(20px);
  // border-top: 1px solid rgba(0, 131, 140, 0.12);
  display: flex;
  justify-content: center;
  box-sizing: border-box;

  & > * {
    width: 100%;
    max-width: 100%;
  }

  @media (max-width: 480px) {
    padding: 8px 12px 12px;
    padding-bottom: max(12px, env(safe-area-inset-bottom, 12px));
  }
`;

const InputWrap = styled.div`
  position: relative;
  width: 100%;
  animation: ${fadeUp} 0.5s ease forwards 0.4s;
  opacity: 0;
  margin-bottom: 0;

  /* Inside IdleContent only */
  ${IdleContent} & {
    margin-bottom: 12px;
  }
`;

const InputBar = styled.textarea`
  width: 100%;
  padding: 14px 52px 14px 18px;
  border: 1.5px solid ${C.border};
  border-radius: 16px;
  background: rgba(0, 212, 170, 0.04);
  backdrop-filter: blur(20px);
  color: ${C.white};
  font-family: openSans-SemiBold, sans-serif;
  font-size: 0.92rem;
  outline: none;
  resize: none;
  overflow: hidden;
  min-height: 50px;
  max-height: 120px;
  line-height: 1.55;
  display: block;
  transition:
    border-color 0.25s,
    box-shadow 0.25s,
    background 0.25s;
  &::placeholder {
    color: ${C.textMuted};
  }
  &:focus {
    border-color: ${C.teal};
    background: rgba(0, 212, 170, 0.04);
    box-shadow:
      0 0 0 3px ${C.tealGlow},
      0 4px 24px rgba(0, 212, 170, 0.08);
  }
  @media (max-width: 480px) {
    font-size: 0.875rem;
    padding: 12px 48px 12px 15px;
  }
`;

const SendBtn = styled.button`
  position: absolute;
  right: 8px;
  bottom: 7px;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 12px;
  background: ${(p) =>
    p.$active
      ? `linear-gradient(135deg, ${C.teal} 0%, ${C.tealDark} 100%)`
      : "rgba(0,212,170,0.15)"};
  color: ${(p) => (p.$active ? "#ffffff" : C.textMuted)};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  box-shadow: ${(p) =>
    p.$active ? `0 4px 16px rgba(0,212,170,0.35)` : "none"};
  &:hover {
    transform: scale(1.08);
  }
  &:active {
    transform: scale(0.94);
  }
`;

const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
  max-width: 720px;
  margin: 12px auto 0;
  font-family: openSans-Italic, sans-serif;
  opacity: 0;
  animation: ${fadeUp} 0.5s ease forwards 0.55s;
`;

const ChipsRow = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  font-family: openSans-Italic, sans-serif;
  @media (max-width: 768px) {
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: 2px;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

const Chip = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding: 6px 14px 6px 14px;
  border-radius: 20px;
  cursor: pointer;
  white-space: nowrap;
  border: 1px solid ${(p) => (p.$case ? "rgba(0,212,170,0.3)" : C.border)};
  background: ${(p) =>
    p.$case ? "rgba(0,212,170,0.07)" : "rgba(255,255,255,0.04)"};

  color: rgba(255, 255, 255, 0.75);
  font-size: 0.75rem;
  font-family: openSans-Italic, sans-serif;

  transition: all 0.2s;
  flex-shrink: 0;

  ${(p) =>
    p.$comingSoon &&
    `
    padding-right: 32px;   

    &::after {
      content: "Coming Soon";
      position: absolute;
      top: -10px;
      right: -6px;

      font-size: 9.5px;        
      font-weight: 700;
      padding: 2px 8px;        
      line-height: 1.1;
      letter-spacing: 0.3px;

      background: linear-gradient(135deg, #00838c, #00838c);
      color: white;
      border-radius: 12px;     
      white-space: nowrap;
      box-shadow: 0 3px 8px rgba(0, 0, 0, 0.35);

      /* Better stability when zooming */
      transform: translateX(0);
      pointer-events: none;
      z-index: 2;
    }
  `}
`;

const MsgButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
`;
const MsgBtn = styled.button`
  padding: 7px 16px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.04);
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.78rem;
  font-family: openSans-Italic, sans-serif;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background: rgba(0, 212, 170, 0.14);
    border-color: ${C.teal};
    color: ${C.white};
  }
`;

const InlineWrap = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 7px;
`;
const CaseInput = styled.input`
  width: 100%;
  padding: 10px 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.05);
  color: ${C.white};
  font-family: openSans-SemiBold, sans-serif;
  font-size: 0.875rem;
  outline: none;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
  &::placeholder {
    color: ${C.textMuted};
  }
  &:focus {
    border-color: ${C.teal};
    box-shadow: 0 0 0 2px ${C.tealGlow2};
  }
`;

const CustomTextArea = styled(TextareaAutosize)`
  width: 100%;
  padding: 10px 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.05);
  color: ${C.white};
  font-family: openSans-SemiBold, sans-serif;
  font-size: 0.875rem;
  outline: none;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
  &::placeholder {
    color: ${C.textMuted};
  }
  &:focus {
    border-color: ${C.teal};
    box-shadow: 0 0 0 2px ${C.tealGlow2};
  }
`;
const CaseSelect = styled.select`
  width: 100%;
  padding: 10px 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  background: rgba(10, 20, 40, 0.9);
  color: ${C.white};
  font-family: openSans-SemiBold, sans-serif;
  font-size: 0.875rem;
  outline: none;
  cursor: pointer;
  &:focus {
    border-color: ${C.teal};
  }
`;
const CaseBtn = styled.button`
  align-self: flex-start;
  padding: 9px 22px;
  border: none;
  border-radius: 22px;
  background: linear-gradient(135deg, ${C.teal} 0%, ${C.tealDark} 100%);
  color: #ffffff;
  font-size: 0.83rem;
  font-weight: 700;
  font-family: openSans-SemiBold, sans-serif;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 16px rgba(0, 212, 170, 0.3);
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 24px rgba(0, 212, 170, 0.4);
  }
  &:active {
    transform: translateY(0);
  }
`;
const PhoneRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: stretch;
`;
const OtpRow = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;
`;
const OtpBox = styled.input`
  width: 44px;
  height: 50px;
  text-align: center;
  font-size: 1.2rem;
  font-weight: 700;
  border: 1.5px solid ${(p) => (p.$filled ? C.teal : "rgba(255,255,255,0.12)")};
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.05);
  color: ${C.white};
  outline: none;
  font-family: openSans-SemiBold, sans-serif;
  transition: border-color 0.18s;
  &:focus {
    border-color: ${C.teal};
    box-shadow: 0 0 0 2px ${C.tealGlow2};
  }
  @media (max-width: 360px) {
    width: 36px;
    height: 44px;
    font-size: 1rem;
  }
`;

const CardWrap = styled.div`
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.09);
  border-radius: 16px;
  padding: 16px;
  margin-top: 10px;
  backdrop-filter: blur(10px);
`;
const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  gap: 8px;
`;
const CardId = styled.span`
  font-weight: 700;
  font-size: 0.85rem;
  color: ${C.white};
  letter-spacing: 0.02em;
`;
const StatusBadge = styled.span`
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  white-space: nowrap;
  ${(p) =>
    p.$type === "active" &&
    css`
      background: rgba(34, 197, 94, 0.12);
      color: #4ade80;
      border: 1px solid rgba(34, 197, 94, 0.28);
    `}
  ${(p) =>
    p.$type === "resolved" &&
    css`
      background: rgba(0, 212, 170, 0.12);
      color: ${C.teal};
      border: 1px solid rgba(0, 212, 170, 0.28);
    `}
  ${(p) =>
    p.$type === "review" &&
    css`
      background: rgba(245, 158, 11, 0.1);
      color: #fcd34d;
      border: 1px solid rgba(245, 158, 11, 0.25);
    `}
`;
const CardRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  padding: 5px 0;
  font-size: 0.8rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  &:last-of-type {
    border-bottom: none;
  }
  span:first-child {
    color: ${C.textMuted};
    flex-shrink: 0;
  }
  span:last-child {
    color: rgba(255, 255, 255, 0.85);
    font-weight: 500;
    text-align: right;
  }
`;
const CardHighlight = styled.div`
  margin-top: 10px;
  padding: 10px 14px;
  border-radius: 10px;
  font-size: 0.8rem;
  line-height: 1.5;
  ${(p) =>
    p.$type === "hearing" &&
    css`
      background: rgba(0, 212, 170, 0.08);
      border: 1px solid rgba(0, 212, 170, 0.2);
      color: #5eead4;
    `}
  ${(p) =>
    p.$type === "action" &&
    css`
      background: rgba(245, 158, 11, 0.08);
      border: 1px solid rgba(245, 158, 11, 0.22);
      color: #fcd34d;
    `}
`;
